import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';
import { site } from '../data/site';
const footerLinks = [{
  label: 'Home',
  href: '#top'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Our Work',
  href: '#work'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}, {
  label: 'Request an Estimate',
  href: '#contact'
}];
export function Footer() {
  return <footer className="bg-ink-900 pb-28 pt-20 sm:pb-16" data-id="element-162" data-mp="3ug3fzmf5elbb">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-163" data-mp="38qtqszerhoj">
        <div className="grid gap-12 border-b border-white/10 pb-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-164" data-mp="387g3ogsjfgb">
          <div data-id="element-165" data-mp="3ldu874b9l61m">
            <p className="font-display text-xl tracking-[0.16em] text-white" data-id="element-166" data-mp="3lggb2qn7mxdi">
              UNBELIEVABLE
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.32em] text-brass-light/80" data-id="element-167" data-mp="29z6woiixuvj2">
              Remodeling &amp; Painting
            </p>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/55" data-id="element-168" data-mp="2ez1nkm2prl44">
              Professional remodeling and painting services for Kentucky homeowners.
            </p>
            <div className="mt-7 flex gap-3" data-id="element-169" data-mp="3gbiliokp7i08">
              {[{
              Icon: Facebook,
              label: 'Facebook'
            }, {
              Icon: Instagram,
              label: 'Instagram'
            }].map(({
              Icon,
              label
            }) => <a key={label} href="#top" aria-label={label} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-brass hover:text-brass" data-id="element-170" data-mp="3q726wh1myyaq">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-171" data-mp="huwgerdjjr3n" />
                </a>)}
            </div>
          </div>

          <nav aria-label="Footer" data-id="element-172" data-mp="qt04nvfwv1z5">
            <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-173" data-mp="qub4xla5drli">
              Explore
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-174" data-mp="mq3glp7lqdnt">
              {footerLinks.map(link => <li key={link.label} data-id="element-175" data-mp="tt088o5w6ipf">
                  <a href={link.href} className="text-[15px] text-white/70 transition-colors hover:text-brass-light" data-id="element-176" data-mp="yto901jxadwu">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-177" data-mp="1cm43uf2o75mo">
            <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-178" data-mp="1ckknkoh0kukw">
              Contact
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-179" data-mp="1hiukb3ie038m">
              <li data-id="element-180" data-mp="1mk1utabwzgiz">
                <a href={site.phoneHref} className="flex items-center gap-3 text-[15px] text-white/70 transition-colors hover:text-brass-light" data-id="element-181" data-mp="1mjihk6x7lgba">
                  <Phone className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-182" data-mp="3obwwqy8dc6o0" />
                  {site.phoneDisplay}
                </a>
              </li>
              <li data-id="element-183" data-mp="3tc2vszgywvg4">
                <a href={`mailto:${site.email}`} className="flex items-center gap-3 text-[15px] text-white/70 transition-colors hover:text-brass-light" data-id="element-184" data-mp="2aevf3w32tu7d">
                  <Mail className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-185" data-mp="21ma97gkjnhzy" />
                  {site.email}
                </a>
              </li>
              <li className="pt-2 text-[15px] leading-relaxed text-white/50" data-id="element-186" data-mp="1wpa3x7viqj9w">
                {site.serviceArea}
              </li>
            </ul>
          </div>
        </div>

        <p className="pt-8 text-[13px] text-white/40" data-id="element-187" data-mp="2pdfq7z280gbu">
          &copy; 2026 Unbelievable Remodeling &amp; Painting. All Rights Reserved.
        </p>
      </div>
    </footer>;
}